module.exports = function removeHighlightClassOnListingPage() {
  const body = document.querySelector('body');
  if (body.classList.contains('listing-page')) {
    const maxWidthHighlightTile = document.querySelector('li.selectedMaxWidth');
    if (maxWidthHighlightTile) {
      maxWidthHighlightTile.classList.remove('highlight');
    }
  }
};



// WEBPACK FOOTER //
// ./scriptPartials/removeHighlightTile.js